import { ProfilePage } from "./ProfilePage";

interface ProfileProps {
  userType: "investor";
}

export function Profile({ userType }: ProfileProps) {
  return <ProfilePage userType={userType} />;
}